
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

/**
 * `Tab Item` - This component represents an item for the tabs component (as in a placeholder).
 */

export default ComponentInitializeDispatcher.extend({
  name: 'owc-tab-item',
  components: {
    SlotContainer,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
});
